import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Modal from "../../common/modal";
import Loader from "../../common/loader";
import {
  addConfig,
  deleteConfig,
  fetchConfig,
  updateConfig,
  updateConfigStatus,
} from "../../redux/adminReducer";
import { toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

function Charges() {
  const { lang, translations, dir } = useSelector((state) => state.language);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [configToDelete, setConfigToDelete] = useState(null);
  const [configToUpdate, setConfigToUpdate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const itemsPerPage = 10;
  const [configName, setConfigName] = useState("101");
  const [configType, setConfigType] = useState("PERCENTAGE");
  const [configValue, setConfigValue] = useState("");
  const [configDescription, setConfigDescription] = useState("");
  const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

  const configs = useSelector(
    (state) => state.admin.configs?.data?.config || []
  );
  const totalConfigData = useSelector(
    (state) => state.admin.configs?.data?.totalData || 0
  );

  useEffect(() => {
    setLoading(true);
    dispatch(fetchConfig(currentPage)).then(() => {
      setLoading(false);
    });
  }, [dispatch, currentPage]);

  const handleDeleteClick = (service) => {
    setConfigToDelete(service);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (configToDelete) {
      setLoading(true);
      dispatch(deleteConfig(configToDelete._id))
        .then(() => {
          dispatch(fetchConfig(currentPage));
          toast.success(translations.toaster.configdeletedSuccessfully);
        })
        .catch((error) => {
          console.error("Delete failed", error);
        })
        .finally(() => {
          setLoading(false);
          setIsModalOpen(false);
          setConfigToDelete(null);
        });
    }
  };

  const handleUpdateClick = (category) => {
    setConfigToUpdate(category);
    setConfigName(category.name);
    setConfigType(category.type);
    setConfigValue(category.value);
    setConfigDescription(category.description);
    setIsUpdateModalOpen(true);
  };

  const handleUpdateConfig = () => {
    if (!configToUpdate) return;
    setLoading(true);
    const payload = {
      _id: configToUpdate._id,
    };

    // Only include name if it has changed
    if (configName !== configToUpdate.name) {
      payload.name = configName;
    }

    // Only include type if it has changed
    if (configType !== configToUpdate.type) {
      payload.type = configType;
    }

    // Only include value if it is not empty
    if (
      configValue !== undefined &&
      configValue !== null &&
      configValue.toString().trim() !== ""
    ) {
      payload.value = parseFloat(configValue);
    }

    // Only include description if it is not empty
    if (configDescription.trim() !== "") {
      payload.description = configDescription.trim();
    }

    dispatch(updateConfig(payload))
      .then(() => {
        dispatch(fetchConfig(currentPage));
        toast.success(translations.toaster.configUpdatedsuccessfully);
      })
      .catch((err) => {
        console.error("Update failed", err);
      })
      .finally(() => {
        setLoading(false);
        setIsUpdateModalOpen(false); // Fixed: should close update modal, not add modal
        setConfigName("101");
        setConfigType("PERCENTAGE");
        setConfigValue("");
        setConfigDescription("");
      });
  };

  const handleAddConfig = () => {
    if (configName) {
      setLoading(true);
      const payload = {
        name: configName,
        type: configType,
        value: configValue,
        description: configDescription,
      };
      dispatch(addConfig(payload))
        .then(() => {
          dispatch(fetchConfig(currentPage));
          setLoading(false);
          toast.success(translations.toaster.configaddedsuccessfully);
        })
        .catch((error) => {
          console.error("Not added", error);
          setLoading(false);
        })
        .finally(() => {
          setIsAddModalOpen(false);
          setConfigName("101");
          setConfigType("PERCENTAGE");
          setConfigValue("");
          setConfigDescription("");
        });
    }
  };

  const statusConfigs = (configId) => {
    setLoading(true);
    dispatch(updateConfigStatus(configId))
      .then(() => {
        dispatch(fetchConfig(currentPage));
        setLoading(false);
        toast.success(translations.toaster.configstatusupdatedsuccessfully);
      })
      .catch((error) => {
        console.error("Failed to update config status", error);
        setLoading(false);
        toast.error(translations.toaster.failedtoupdateconfigstatus);
      })
      .finally(() => {
        setIsWarnModalOpen(false);
        setConfigToUpdate(null);
      });
  };

  const [error, setError] = useState("");
  const handlePageChange = (event) => {
    const selectedPage = Number(event.target.value);

    if (selectedPage > totalPages) {
      setError(`Maximum value must be ${totalPages}`);
      // setCurrentPage(totalPages);
      return;
    }
    setCurrentPage(selectedPage);
    setError("");
  };
  const totalPages = Math.ceil(totalConfigData / itemsPerPage);

  return (
    <>
      <Layout>
        <div className="min-h-screen w-full px-4 py-4">
          <section className="pt-1 grid grid-cols-2 items-center">
            <h1 className="text-xl font-bold text-white">
              {translations.charges.charges}
              <small className="text-2xl font-semibold text-gray-600"> |</small>
              <small className="font-normal text-gray-600">
                {" "}
                {translations.charges.chargesManagement}
              </small>
            </h1>

            <div className="text-md text-white flex items-center justify-end space-x-1 ">
              <div className="rounded-full bg-[#5A189A] py-2 px-3">
                <Link
                  to="/"
                  className=" text-white  no-underline cursor-pointer"
                >
                  {translations.charges.dashboard}
                </Link>
                <span className="mx-1">/</span>
                <span className="text-green-300">
                  {translations.charges.charges}
                </span>
              </div>
            </div>
          </section>
          <div className="p-4 w-full bg-gray-800 shadow-xl rounded mt-5">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-2xl font-semibold text-white">
                    {translations.charges.configList}
                  </h2>
                  <button
                    onClick={() => setIsAddModalOpen(true)}
                    className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded"
                  >
                    {translations.charges.addConfig}
                  </button>
                </div>
                {configs.length === 0 ? (
                  <div className="flex h-64 items-center justify-center text-gray-500 dark:text-gray-400">
                    <p className="text-xl">
                      {translations.salon_request.noData}
                    </p>
                  </div>
                ) : (
                  <div className="grid  md:grid lg:grid  overflow-x-auto ">
                    <table className="min-w-full divide-y divide-gray-600 text-white">
                      <thead className="bg-[#5A189A] text-center">
                        <tr>
                          <th className="px-4 py-2 ">
                            {translations.charges.name}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.charges.type}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.charges.value}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.charges.description}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.charges.status}
                          </th>
                          <th className="px-4 py-2 ">
                            {translations.charges.actions}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {configs.map((cat, index) => (
                          <tr key={index} className=" text-center">
                            <td className="px-4 py-2">
                              {cat.name === 102 ? "VAT" : "Platform Charge"}
                            </td>
                            <td className="px-4 py-2">{cat.type}</td>
                            <td className="px-4 py-2">{cat.value}</td>
                            <td className="px-4 py-2">{cat.description}</td>
                            <td className="px-4 py-3">
                              <span
                                onClick={() => {
                                  setConfigToUpdate(cat);
                                  setIsWarnModalOpen(true);
                                }}
                                className={`bg-gray-600 px-4 py-1 rounded-full whitespace-nowrap cursor-pointer ${
                                  cat.active === true
                                    ? "text-green-600"
                                    : "text-red-500 "
                                }`}
                              >
                                {cat.active === true ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td className="px-4 py-3 flex justify-center">
                              <button
                                onClick={() => handleUpdateClick(cat)}
                                className="text-green-600 hover:text-green-300 px-2  text-xl"
                              >
                                <FaRegEdit />
                              </button>
                              <button
                                onClick={() => handleDeleteClick(cat)}
                                className="text-red-700  hover:text-red-500  text-2xl"
                              >
                                <MdDelete />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div className="mt-4 flex justify-between text-white">
                      <svg
                        className={`${
                          currentPage === 1
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        width={24}
                        height={24}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        aria-disabled={currentPage === 1}
                      >
                        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                      </svg>
                      <span>
                        {translations.charges.page}
                        {totalPages > 1 ? (
                          <input
                            type="number"
                            name=""
                            id="pagination-jump"
                            className={
                              error
                                ? `mx-2 rounded-md border  ps-1 border-red  bg-gray-800 text-white shadow-card focus:border-primary`
                                : `mx-2 rounded-md border border-gray-300 ps-1  bg-gray-800 text-white shadow-card focus:border-primary`
                            }
                            min={1}
                            max={totalPages}
                            defaultValue={currentPage}
                            onChange={(e) => e.target.value}
                            onBlur={(e) => handlePageChange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handlePageChange(e);
                              }
                            }}
                          />
                        ) : (
                          <span className="mx-1">{currentPage}</span>
                        )}
                        {translations.charges.of} {totalPages}
                      </span>
                      <svg
                        className={`${
                          currentPage === totalPages
                            ? "fill-current"
                            : "cursor-pointer fill-current"
                        }
                        ${dir === "rtl" && "rotate-180"}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 320 512"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        aria-disabled={currentPage === totalPages}
                      >
                        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
                      </svg>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[85%] lg:w-[70%] max-w-2xl"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6">
          <h3 className="text-xl text-center text-white mb-6">
            {translations.charges.addNewConfig}
          </h3>

          {/* Config Name */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configName}{" "}
            <span className="text-red-400">*</span>
          </label>
          <select
            value={configName}
            onChange={(e) => setConfigName(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="101">{translations.charges.platformCharge}</option>
            <option value="102">{translations.charges.vat}</option>
          </select>

          {/* Config Type */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configType}{" "}
            <span className="text-red-400">*</span>
          </label>
          <select
            value={configType}
            onChange={(e) => setConfigType(e.target.value)}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="PERCENTAGE">
              {translations.charges.percentage}
            </option>
            <option value="FIXED">{translations.charges.fixed}</option>
          </select>

          {/* Config Value */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configValue}{" "}
            <span className="text-red-400">*</span>
          </label>
          <input
            type="number"
            value={configValue}
            onChange={(e) => setConfigValue(e.target.value)}
            placeholder="0"
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          />

          {/* Config Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configDescription}{" "}
            <span className="text-red-400">*</span>
          </label>
          <textarea
            value={configDescription}
            onChange={(e) => setConfigDescription(e.target.value)}
            placeholder={translations.charges.enterdescription}
            className="w-full rounded-md border border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3 resize-none h-20"
          />

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsAddModalOpen(false);
                setConfigName("101");
                setConfigType("PERCENTAGE");
                setConfigValue("");
                setConfigDescription("");
              }}
              className="w-full sm:w-auto px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.charges.cancel}
            </button>
            <button
              onClick={handleAddConfig}
              className="w-full sm:w-auto px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            >
              {translations.charges.submit}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[40%] max-w-md"
      >
        <div className="w-full px-4 sm:px-6 md:px-8 py-6 text-white mx-auto">
          <h2 className="text-xl font-semibold mb-4 text-red-600 text-center sm:text-left">
            {translations.charges.confirmDelete}
          </h2>

          <p className="mb-6 text-center sm:text-left">
            {translations.charges.warning}
          </p>

          <div className="flex flex-col sm:flex-row justify-end gap-3">
            <button
              className="w-full sm:w-auto bg-gray-500 px-4 py-2 rounded hover:bg-gray-400"
              onClick={() => setIsModalOpen(false)}
            >
              {translations.charges.cancel}
            </button>
            <button
              className="w-full sm:w-auto bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
              onClick={() => {
                confirmDelete();
                setIsModalOpen(false);
              }}
            >
              {translations.charges.delete}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isUpdateModalOpen}
        onClose={() => setIsUpdateModalOpen(false)}
        width="w-[90%] max-w-md"
      >
        <div className="p-6 w-96">
          <h3 className="text-xl text-center text-white mb-6">
            {translations.charges.updateConfig}
          </h3>

          {/* Config Name */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configName}{" "}
            <span className="text-red-400">*</span>
          </label>
          <select
            value={configName}
            onChange={(e) => setConfigName(e.target.value)}
            className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="101">{translations.charges.platformCharge}</option>
            <option value="102">{translations.charges.vat}</option>
          </select>

          {/* Config Type */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configType}{" "}
            <span className="text-red-400">*</span>
          </label>
          <select
            value={configType}
            onChange={(e) => setConfigType(e.target.value)}
            className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          >
            <option value="PERCENTAGE">
              {translations.charges.percentage}
            </option>
            <option value="FIXED">{translations.charges.fixed}</option>
          </select>

          {/* Config Value */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configValue}{" "}
            <span className="text-red-400">*</span>
          </label>
          <input
            type="number"
            value={configValue}
            onChange={(e) => setConfigValue(e.target.value)}
            placeholder="0"
            className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3"
          />

          {/* Config Description */}
          <label className="block text-gray-400 text-sm mb-1">
            {translations.charges.configDescription}{" "}
            <span className="text-red-400">*</span>
          </label>
          <textarea
            value={configDescription}
            onChange={(e) => setConfigDescription(e.target.value)}
            placeholder={translations.charges.enterdescription}
            className="w-full rounded-md border-[1.5px] border-dark-3 bg-gray-700 text-white px-4 py-2.5 mb-3 resize-none h-20"
          />

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setIsAddModalOpen(false);
                setConfigName("101");
                setConfigType("PERCENTAGE");
                setConfigValue("");
                setConfigDescription("");
              }}
              className="px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500"
            >
              {translations.charges.cancel}
            </button>
            <button
              onClick={handleUpdateConfig}
              className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            >
              {translations.charges.submit}
            </button>
          </div>
        </div>
      </Modal>

      {/* update coupon status modal */}
      <Modal
        isOpen={isWarnModalOpen}
        onClose={() => {
          setIsWarnModalOpen(false);
          setConfigToUpdate(null);
        }}
        width="w-[450px]"
      >
        <div className="p-6">
          <h2 className="mb-6 text-xl font-bold text-white">
            {translations.charges.confirmStatusChange}
          </h2>

          <div className="mb-4 rounded-md border border-yellow-300 bg-yellow-200 p-4 text-yellow-800">
            {configToUpdate?.active === true ? (
              <>
                <strong>{translations.service.warning}:</strong>{" "}
                {translations.charges.thiswill}{" "}
                <b>{translations.charges.deactivate}</b>{" "}
                {
                  translations.charges
                    .theconfigurationThesystemwillignorethissettinguntilitreactivated
                }
              </>
            ) : (
              <>
                <strong>{translations.charges.notice}:</strong>{" "}
                {translations.charges.thiswill}{" "}
                <b>{translations.charges.activate}</b>{" "}
                {
                  translations.charges
                    .theconfigurationItwilltakeeffectandbeusedbythesystemaccordingly
                }
              </>
            )}
          </div>

          <div className="flex justify-end gap-2 text-end">
            <button
              onClick={() =>
                statusConfigs(configToUpdate ? configToUpdate._id : "")
              }
              className="basis-1/4 rounded-md bg-red-600 px-4 py-2 text-white hover:bg-red-700"
            >
              {translations.charges.yes}
            </button>

            <button
              onClick={() => {
                setIsWarnModalOpen(false);
                setConfigToUpdate(null);
              }}
              className="basis-1/4 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              {translations.charges.no}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Charges;
